/**
 * Base64 to UTF-8 decoder with fallback
 */

export function b64ToUtf8(b64: string): string {
  try {
    const bin = atob(b64);
    const bytes = Uint8Array.from(bin, (c) => c.charCodeAt(0));
    const dec = new TextDecoder('utf-8');
    return dec.decode(bytes);
  } catch {
    try {
      return decodeURIComponent(escape(atob(b64)));
    } catch {
      return '';
    }
  }
}
